import { render } from "./now.vue?vue&type=template&id=1173d9b8&scoped=true"
import script from "./now.vue?vue&type=script&lang=js"
export * from "./now.vue?vue&type=script&lang=js"

import "./now.vue?vue&type=style&index=0&id=1173d9b8&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1173d9b8"]])

export default __exports__